import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=e5bc3b16&scoped=true"
import script from "./AboutMe.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutMe.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AboutMe.vue?vue&type=style&index=0&id=e5bc3b16&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5bc3b16",
  null
  
)

export default component.exports